import React from "react";

const Sparkle = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="m15.974 28.747 1.284-2.965c1.142-2.64 3.198-4.74 5.763-5.888l3.534-1.582c1.123-.503 1.123-2.151 0-2.654l-3.423-1.533c-2.631-1.178-4.724-3.356-5.847-6.085l-1.3-3.16a1.38 1.38 0 0 0-2.572 0l-1.3 3.16c-1.123 2.729-3.217 4.907-5.847 6.085l-3.423 1.533c-1.124.503-1.124 2.151 0 2.654l3.533 1.582c2.565 1.148 4.621 3.249 5.763 5.888l1.284 2.965a1.379 1.379 0 0 0 2.551 0Zm12.853 2.795.36-.835a6.414 6.414 0 0 1 3.25-3.32l1.112-.499c.601-.27.601-1.151 0-1.42l-1.05-.471a6.42 6.42 0 0 1-3.296-3.432l-.37-.902a.74.74 0 0 0-1.38 0l-.37.902a6.419 6.419 0 0 1-3.296 3.432l-1.05.47c-.601.27-.601 1.152 0 1.421l1.112.498a6.414 6.414 0 0 1 3.25 3.321l.36.835a.74.74 0 0 0 1.368 0Z"
            fill={fill}
        />
    </svg>
);

export default Sparkle;
